<div class="text-font-primary mb-5 text-base font-bold flex items-center justify-between gap-5">
  <div class="flex items-center gap-4">Transaction Limits</div>

  <button
    [hidden]="!isEditAllowed()"
    class="p-2 text-xl text-secondary rounded-full transition-colors hover:bg-gray-200 -m-2 shrink-0 disabled:bg-white disabled:text-font-tertiary"
    title="Edit Transaction Limits"
    (click)="editClick.emit()"
  >
    <rkt-icon name="edit"></rkt-icon>
  </button>
</div>

<div class="flex flex-col gap-4">
  @for (item of transactionLimits(); track item.id) {
    <app-transaction-limit-item [limitItem]="item" />
  }
</div>
